import { Switch, type SwitchProps } from '@mui/material';
import { forwardRef } from 'react';

/**
 * @tier atom
 *
 * Bare toggle switch — a thin wrapper over MUI `Switch`. All visual
 * treatment (track, thumb, checked/disabled colors) comes from the
 * `MuiSwitch` theme override; this file adds no styling.
 *
 * This is the **control only** — no label, description, or helper text.
 * For the opinionated form row (title + description + helper, switch on
 * the right) compose the `VySwitchRow` molecule, which wraps this atom.
 */
export type VySwitchProps = SwitchProps;

export const VySwitch = forwardRef<HTMLButtonElement, VySwitchProps>(
  function VySwitch(props, ref) {
    return <Switch ref={ref} {...props} />;
  },
);
